import { i18n } from 'i18n';

import { TRANSFORM_LOCALE } from './transformLocale';

export const formatNumber = (number: string | number) => {
	if (isNaN(Number(number))) {
		console.error(`formatNumber: The passed string "${number}" is not a number`);
		return null;
	}

	const locale = TRANSFORM_LOCALE[i18n.language];
	// const locale = i18n.language;
	return Number(number).toLocaleString(locale);
};
